import {
  startOfWeek,
  endOfWeek,
  format,
  startOfMonth,
  endOfMonth,
} from "date-fns";

export function getWeekRange() {
  const date = new Date();
  const start = startOfWeek(date, { weekStartsOn: 0 }); // Domingo
  const end = endOfWeek(date, { weekStartsOn: 0 }); // Sábado

  return {
    startDate: format(start, "yyyy-MM-dd"),
    endDate: format(end, "yyyy-MM-dd"),
  };
}

export function getMonthRange() {
  const date = new Date();
  const start = startOfMonth(date); // Primeiro dia do mês
  const end = endOfMonth(date); // Último dia do mês

  return {
    startDate: format(start, "yyyy-MM-dd"),
    endDate: format(end, "yyyy-MM-dd"),
  };
}

export function getTodayRange() {
  const today = format(new Date(), "yyyy-MM-dd");
  return { startDate: today, endDate: today };
}
